import React, { useEffect } from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormInput from 'common/components/form/ReactHookFormInput';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validateUpdateCreditForm';

const FormEditCredit = ({
    handleClickCloseForm,
    isKam,
    isSaving,
    updateCredit,
    initialValues,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    const handleOnSubmit = (values) => {
        updateCredit(values, () => {
            handleClickCloseForm();
        });
    };

    useEffect(() => reset(initialValues), [initialValues]);

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnSubmit)}>
            <Box hidden={isKam}>
                <ReactHookFormInput
                    name="hitch"
                    control={control}
                    label={t('Hitch')}
                    onlyNumbers
                    placeholder={t('Enter the down payment amount')}
                    prepend="$"
                />
            </Box>

            <ReactHookFormInput
                name="term"
                control={control}
                label={t('Term')}
                onlyNumbers
                placeholder={t('Enter the term')}
                append={t('Months', { count: 2 }).toLowerCase()}
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
                <Button
                    color="secondary"
                    onClick={handleClickCloseForm}
                    variant="text"
                >
                    {t('Cancel')}
                </Button>
                <Button disabled={isSaving} type="submit">
                    {t('Save')}
                </Button>
            </Box>
        </Stack>
    );
};

FormEditCredit.propTypes = {
    handleClickCloseForm: PropTypes.func,
    isKam: PropTypes.bool,
    isSaving: PropTypes.bool,
    updateCredit: PropTypes.func,
    initialValues: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialValuesFormEditCredit,
    isSaving: selectors.getIsSavingItem,
});

const mapDispatchToProps = (dispatch) => ({
    updateCredit: (values, callback) =>
        dispatch(actions.updateCredit(values, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FormEditCredit);
